"use strict";

/**
 *
 *
 */
var rpc = exports;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

/**
 *
 *
 *
 *
 *
 *
 */

rpc.Service = require("./rpc/service");
